import { mapRequest } from './eventMap'

// The tutorial event bus. Events carry a rising sequence so the machine can drop anything that
// happened before the current step began. Failures are published so the guide pauses, never advances.
export interface BusEvent {
  event: string
  seq: number
  workspaceId: string | null
  entityId: string | null
  failed: boolean
}

type Listener = (e: BusEvent) => void

let seq = 0
const listeners = new Set<Listener>()
const succeeded = new Set<string>()

export const currentSeq = (): number => seq

function publish(event: string, opts: { workspaceId?: string | null; entityId?: string | null }, failed: boolean): void {
  seq += 1
  if (!failed) succeeded.add(event)
  const e: BusEvent = { event, seq, workspaceId: opts.workspaceId ?? null, entityId: opts.entityId ?? null, failed }
  listeners.forEach((fn) => fn(e))
}

/** A success with no API response of its own (stream finished, a choice made, an export). */
export function emitTutorialEvent(event: string, opts: { workspaceId?: string | null; entityId?: string | null } = {}): void {
  publish(event, opts, false)
}

export function subscribeTutorialEvents(fn: Listener): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

/** Called by the api.ts response interceptor. status 0 = no answer (network error or abort). */
export function observeApiResponse(res: { method?: string; url?: string; status: number; data?: unknown }): void {
  if (!res.method || !res.url) return
  const ok = res.status >= 200 && res.status < 300
  for (const m of mapRequest(res.method, res.url, res.data)) {
    if (ok && m.after && !succeeded.has(m.after)) continue
    publish(m.event, m, !ok)
  }
}

/** Identity change: forget which prerequisites this session saw. */
export function resetTutorialEvents(): void {
  succeeded.clear()
}
